<div [formGroup]="shareEventForm">
  <label class="p-d-block p-mb-1"><strong>Franchise Zone</strong></label>
  <div class="p-m-1">
    <p-dropdown
      [options]="availableZones"
      class="full-width-dropdown"
      formControlName="zone"
      optionLabel="name"
      appendTo="body"
      dataKey="id"
      placeholder="Select Zone"
      [showClear]="true"
      [filter]="showFilter"
      filterBy="name"
      [resetFilterOnHide]="true"
    >
      <ng-template let-zone pTemplate="item">
        <div class="country-item">
          <div>{{ zone.name }}</div>
        </div>
      </ng-template>
    </p-dropdown>
  </div>

  <div class="p-mt-3 p-mb-1">
    <label class="p-d-block p-mb-1"><strong>Events</strong></label>
    <ng-container *ngIf="eventsInitialized; else eventsLoading">
      <p-listbox
        [options]="events"
        formControlName="selectedEvents"
        optionLabel="title"
        dataKey="id"
        [multiple]="true"
        [checkbox]="true"
        [showToggleAll]="false"
        [listStyle]="{ 'max-height': '160px' }"
      ></p-listbox>
    </ng-container>
    <ng-template #eventsLoading>
      <p-skeleton height="120px"></p-skeleton>
    </ng-template>
    <small class="p-d-block p-mt-1 p-text-secondary">
      <span *ngIf="isUnsharing">
        <i class="pi pi-info-circle p-mr-1"></i>
        No zone selected — saving will unshare the
        {{ isSharingWholeJob ? 'entire job' : 'selected event(s)' }}.
      </span>
      <span *ngIf="!isUnsharing && isSharingWholeJob">
        <i class="pi pi-info-circle p-mr-1"></i>
        No events selected — the entire job will be shared with the selected
        zone.
      </span>
      <span *ngIf="!isUnsharing && !isSharingWholeJob">
        Only the selected event(s) will be shared.
      </span>
    </small>
  </div>

  <br />
  <div class="p-text-right">
    <button
      pButton
      label="Cancel"
      icon="pi pi-times"
      (click)="closeDialog()"
      class="p-m-1"
    ></button>
    <button
      pButton
      [label]="isUnsharing ? 'Unshare' : 'Share'"
      [icon]="isUnsharing ? 'pi pi-times-circle' : 'pi pi-arrow-up-right'"
      (click)="shareEvent()"
      class="p-m-1"
      [class.p-button-danger]="isUnsharing"
      [disabled]="!isReady"
    ></button>
  </div>
</div>
